import {
  ApiResponseError,
  ApiSessionTimeoutError,
  classifyApiError,
  unwrapPagedResponseModel,
  unwrapResponseModel
} from '../api/responseModel';

export {
  ApiResponseError as StudentsApiError,
  ApiSessionTimeoutError as StudentsSessionTimeoutError,
  classifyApiError as classifyStudentsError,
  unwrapPagedResponseModel,
  unwrapResponseModel
};

export function toCreateStudentPayload({ name, dni }) {
  return {
    AlumnoNombre: name,
    AlumnoDni: dni
  };
}

export function toUpdateStudentPayload({ id, name, dni, papelesCompletos }) {
  return {
    AlumnoNombre: name.trim(),
    AlumnoDni: dni.trim(),
    AlumnoCodigo: parseInt(id, 10),
    AlumnoPapelesCompletos: papelesCompletos
  };
}

export function toBulkUploadPayload(archivoBase64) {
  return { Archivo: archivoBase64 };
}
